


















import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import Component from 'vue-class-component';

@Component({
  components: { UiAutocompleClientsSubsidiaries },
})
export default class RulesEngineRuleFilterList extends BaseComponent {
  public filter: any = {
    term: '',
    action: null,
  };

  lastTerm = null;

  public onFilterTerm(val: any): void {
    if (this.lastTerm != null && this.filter.term == this.lastTerm) {
      return;
    }

    this.lastTerm = this.filter.term;
    this.onFilter(val);
  }

  public onFilter(val: any): void {
    this.$emit('filter', this.filter);
  }
}
